module.exports = __webpack_public_path__ + "static/media/3093706-394x392.4d2a4618.jpg";